/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MembersRouteImport } from './routes/members'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvitationsRouteImport } from './routes/invitations'
import { Route as GuardRouteImport } from './routes/guard'
import { Route as DevtoolsRouteImport } from './routes/devtools'
import { Route as AmenitiesRouteImport } from './routes/amenities'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TicketsIndexRouteImport } from './routes/tickets.index'
import { Route as InvitationsIndexRouteImport } from './routes/invitations.index'
import { Route as GuardIndexRouteImport } from './routes/guard.index'
import { Route as AmenitiesIndexRouteImport } from './routes/amenities.index'
import { Route as TicketsNewRouteImport } from './routes/tickets.new'
import { Route as TicketsTicketIdRouteImport } from './routes/tickets.$ticketId'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as InvitationsManageRouteImport } from './routes/invitations.manage'
import { Route as InvitationsCreateRouteImport } from './routes/invitations.create'
import { Route as InvitationsAccessLogRouteImport } from './routes/invitations.access-log'
import { Route as CommunicationsCreateRouteImport } from './routes/communications.create'
import { Route as AmenitiesManageRouteImport } from './routes/amenities.manage'
import { Route as AmenitiesAmenityIdRouteImport } from './routes/amenities.$amenityId'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminMyAccessRouteImport } from './routes/admin.my-access'
import { Route as AdminCommunitiesRouteImport } from './routes/admin.communities'
import { Route as AdminCommunicationsRouteImport } from './routes/admin.communications'

const TicketsRoute = TicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MembersRoute = MembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsRoute = InvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => rootRouteImport,
} as any)
const GuardRoute = GuardRouteImport.update({
  id: '/guard',
  path: '/guard',
  getParentRoute: () => rootRouteImport,
} as any)
const DevtoolsRoute = DevtoolsRouteImport.update({
  id: '/devtools',
  path: '/devtools',
  getParentRoute: () => rootRouteImport,
} as any)
const AmenitiesRoute = AmenitiesRouteImport.update({
  id: '/amenities',
  path: '/amenities',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TicketsRoute,
} as any)
const InvitationsIndexRoute = InvitationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvitationsRoute,
} as any)
const GuardIndexRoute = GuardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuardRoute,
} as any)
const AmenitiesIndexRoute = AmenitiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AmenitiesRoute,
} as any)
const TicketsNewRoute = TicketsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => TicketsRoute,
} as any)
const TicketsTicketIdRoute = TicketsTicketIdRouteImport.update({
  id: '/$ticketId',
  path: '/$ticketId',
  getParentRoute: () => TicketsRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsManageRoute = InvitationsManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => InvitationsRoute,
} as any)
const InvitationsCreateRoute = InvitationsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => InvitationsRoute,
} as any)
const InvitationsAccessLogRoute = InvitationsAccessLogRouteImport.update({
  id: '/access-log',
  path: '/access-log',
  getParentRoute: () => InvitationsRoute,
} as any)
const CommunicationsCreateRoute = CommunicationsCreateRouteImport.update({
  id: '/communications/create',
  path: '/communications/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AmenitiesManageRoute = AmenitiesManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => AmenitiesRoute,
} as any)
const AmenitiesAmenityIdRoute = AmenitiesAmenityIdRouteImport.update({
  id: '/$amenityId',
  path: '/$amenityId',
  getParentRoute: () => AmenitiesRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyAccessRoute = AdminMyAccessRouteImport.update({
  id: '/my-access',
  path: '/my-access',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCommunitiesRoute = AdminCommunitiesRouteImport.update({
  id: '/communities',
  path: '/communities',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCommunicationsRoute = AdminCommunicationsRouteImport.update({
  id: '/communications',
  path: '/communications',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/amenities': typeof AmenitiesRouteWithChildren
  '/devtools': typeof DevtoolsRoute
  '/guard': typeof GuardRouteWithChildren
  '/invitations': typeof InvitationsRouteWithChildren
  '/login': typeof LoginRoute
  '/members': typeof MembersRoute
  '/notifications': typeof NotificationsRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/tickets': typeof TicketsRouteWithChildren
  '/admin/communications': typeof AdminCommunicationsRoute
  '/admin/communities': typeof AdminCommunitiesRoute
  '/admin/my-access': typeof AdminMyAccessRoute
  '/admin/users': typeof AdminUsersRoute
  '/amenities/$amenityId': typeof AmenitiesAmenityIdRoute
  '/amenities/manage': typeof AmenitiesManageRoute
  '/communications/create': typeof CommunicationsCreateRoute
  '/invitations/access-log': typeof InvitationsAccessLogRoute
  '/invitations/create': typeof InvitationsCreateRoute
  '/invitations/manage': typeof InvitationsManageRoute
  '/invite/$token': typeof InviteTokenRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/amenities/': typeof AmenitiesIndexRoute
  '/guard/': typeof GuardIndexRoute
  '/invitations/': typeof InvitationsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/devtools': typeof DevtoolsRoute
  '/login': typeof LoginRoute
  '/members': typeof MembersRoute
  '/notifications': typeof NotificationsRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/admin/communications': typeof AdminCommunicationsRoute
  '/admin/communities': typeof AdminCommunitiesRoute
  '/admin/my-access': typeof AdminMyAccessRoute
  '/admin/users': typeof AdminUsersRoute
  '/amenities/$amenityId': typeof AmenitiesAmenityIdRoute
  '/amenities/manage': typeof AmenitiesManageRoute
  '/communications/create': typeof CommunicationsCreateRoute
  '/invitations/access-log': typeof InvitationsAccessLogRoute
  '/invitations/create': typeof InvitationsCreateRoute
  '/invitations/manage': typeof InvitationsManageRoute
  '/invite/$token': typeof InviteTokenRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/amenities': typeof AmenitiesIndexRoute
  '/guard': typeof GuardIndexRoute
  '/invitations': typeof InvitationsIndexRoute
  '/tickets': typeof TicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/amenities': typeof AmenitiesRouteWithChildren
  '/devtools': typeof DevtoolsRoute
  '/guard': typeof GuardRouteWithChildren
  '/invitations': typeof InvitationsRouteWithChildren
  '/login': typeof LoginRoute
  '/members': typeof MembersRoute
  '/notifications': typeof NotificationsRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/tickets': typeof TicketsRouteWithChildren
  '/admin/communications': typeof AdminCommunicationsRoute
  '/admin/communities': typeof AdminCommunitiesRoute
  '/admin/my-access': typeof AdminMyAccessRoute
  '/admin/users': typeof AdminUsersRoute
  '/amenities/$amenityId': typeof AmenitiesAmenityIdRoute
  '/amenities/manage': typeof AmenitiesManageRoute
  '/communications/create': typeof CommunicationsCreateRoute
  '/invitations/access-log': typeof InvitationsAccessLogRoute
  '/invitations/create': typeof InvitationsCreateRoute
  '/invitations/manage': typeof InvitationsManageRoute
  '/invite/$token': typeof InviteTokenRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/tickets/new': typeof TicketsNewRoute
  '/amenities/': typeof AmenitiesIndexRoute
  '/guard/': typeof GuardIndexRoute
  '/invitations/': typeof InvitationsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/amenities'
    | '/devtools'
    | '/guard'
    | '/invitations'
    | '/login'
    | '/members'
    | '/notifications'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/tickets'
    | '/admin/communications'
    | '/admin/communities'
    | '/admin/my-access'
    | '/admin/users'
    | '/amenities/$amenityId'
    | '/amenities/manage'
    | '/communications/create'
    | '/invitations/access-log'
    | '/invitations/create'
    | '/invitations/manage'
    | '/invite/$token'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/amenities/'
    | '/guard/'
    | '/invitations/'
    | '/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/devtools'
    | '/login'
    | '/members'
    | '/notifications'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/admin/communications'
    | '/admin/communities'
    | '/admin/my-access'
    | '/admin/users'
    | '/amenities/$amenityId'
    | '/amenities/manage'
    | '/communications/create'
    | '/invitations/access-log'
    | '/invitations/create'
    | '/invitations/manage'
    | '/invite/$token'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/amenities'
    | '/guard'
    | '/invitations'
    | '/tickets'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/amenities'
    | '/devtools'
    | '/guard'
    | '/invitations'
    | '/login'
    | '/members'
    | '/notifications'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/tickets'
    | '/admin/communications'
    | '/admin/communities'
    | '/admin/my-access'
    | '/admin/users'
    | '/amenities/$amenityId'
    | '/amenities/manage'
    | '/communications/create'
    | '/invitations/access-log'
    | '/invitations/create'
    | '/invitations/manage'
    | '/invite/$token'
    | '/tickets/$ticketId'
    | '/tickets/new'
    | '/amenities/'
    | '/guard/'
    | '/invitations/'
    | '/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AmenitiesRoute: typeof AmenitiesRouteWithChildren
  DevtoolsRoute: typeof DevtoolsRoute
  GuardRoute: typeof GuardRouteWithChildren
  InvitationsRoute: typeof InvitationsRouteWithChildren
  LoginRoute: typeof LoginRoute
  MembersRoute: typeof MembersRoute
  NotificationsRoute: typeof NotificationsRoute
  PrivacyRoute: typeof PrivacyRoute
  SettingsRoute: typeof SettingsRoute
  TermsRoute: typeof TermsRoute
  TicketsRoute: typeof TicketsRouteWithChildren
  CommunicationsCreateRoute: typeof CommunicationsCreateRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tickets': {
      id: '/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof TicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/members': {
      id: '/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof MembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations': {
      id: '/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof InvitationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guard': {
      id: '/guard'
      path: '/guard'
      fullPath: '/guard'
      preLoaderRoute: typeof GuardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devtools': {
      id: '/devtools'
      path: '/devtools'
      fullPath: '/devtools'
      preLoaderRoute: typeof DevtoolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/amenities': {
      id: '/amenities'
      path: '/amenities'
      fullPath: '/amenities'
      preLoaderRoute: typeof AmenitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof TicketsRoute
    }
    '/invitations/': {
      id: '/invitations/'
      path: '/'
      fullPath: '/invitations/'
      preLoaderRoute: typeof InvitationsIndexRouteImport
      parentRoute: typeof InvitationsRoute
    }
    '/guard/': {
      id: '/guard/'
      path: '/'
      fullPath: '/guard/'
      preLoaderRoute: typeof GuardIndexRouteImport
      parentRoute: typeof GuardRoute
    }
    '/amenities/': {
      id: '/amenities/'
      path: '/'
      fullPath: '/amenities/'
      preLoaderRoute: typeof AmenitiesIndexRouteImport
      parentRoute: typeof AmenitiesRoute
    }
    '/tickets/new': {
      id: '/tickets/new'
      path: '/new'
      fullPath: '/tickets/new'
      preLoaderRoute: typeof TicketsNewRouteImport
      parentRoute: typeof TicketsRoute
    }
    '/tickets/$ticketId': {
      id: '/tickets/$ticketId'
      path: '/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof TicketsTicketIdRouteImport
      parentRoute: typeof TicketsRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/manage': {
      id: '/invitations/manage'
      path: '/manage'
      fullPath: '/invitations/manage'
      preLoaderRoute: typeof InvitationsManageRouteImport
      parentRoute: typeof InvitationsRoute
    }
    '/invitations/create': {
      id: '/invitations/create'
      path: '/create'
      fullPath: '/invitations/create'
      preLoaderRoute: typeof InvitationsCreateRouteImport
      parentRoute: typeof InvitationsRoute
    }
    '/invitations/access-log': {
      id: '/invitations/access-log'
      path: '/access-log'
      fullPath: '/invitations/access-log'
      preLoaderRoute: typeof InvitationsAccessLogRouteImport
      parentRoute: typeof InvitationsRoute
    }
    '/communications/create': {
      id: '/communications/create'
      path: '/communications/create'
      fullPath: '/communications/create'
      preLoaderRoute: typeof CommunicationsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/amenities/manage': {
      id: '/amenities/manage'
      path: '/manage'
      fullPath: '/amenities/manage'
      preLoaderRoute: typeof AmenitiesManageRouteImport
      parentRoute: typeof AmenitiesRoute
    }
    '/amenities/$amenityId': {
      id: '/amenities/$amenityId'
      path: '/$amenityId'
      fullPath: '/amenities/$amenityId'
      preLoaderRoute: typeof AmenitiesAmenityIdRouteImport
      parentRoute: typeof AmenitiesRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/my-access': {
      id: '/admin/my-access'
      path: '/my-access'
      fullPath: '/admin/my-access'
      preLoaderRoute: typeof AdminMyAccessRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/communities': {
      id: '/admin/communities'
      path: '/communities'
      fullPath: '/admin/communities'
      preLoaderRoute: typeof AdminCommunitiesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/communications': {
      id: '/admin/communications'
      path: '/communications'
      fullPath: '/admin/communications'
      preLoaderRoute: typeof AdminCommunicationsRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminCommunicationsRoute: typeof AdminCommunicationsRoute
  AdminCommunitiesRoute: typeof AdminCommunitiesRoute
  AdminMyAccessRoute: typeof AdminMyAccessRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCommunicationsRoute: AdminCommunicationsRoute,
  AdminCommunitiesRoute: AdminCommunitiesRoute,
  AdminMyAccessRoute: AdminMyAccessRoute,
  AdminUsersRoute: AdminUsersRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AmenitiesRouteChildren {
  AmenitiesAmenityIdRoute: typeof AmenitiesAmenityIdRoute
  AmenitiesManageRoute: typeof AmenitiesManageRoute
  AmenitiesIndexRoute: typeof AmenitiesIndexRoute
}

const AmenitiesRouteChildren: AmenitiesRouteChildren = {
  AmenitiesAmenityIdRoute: AmenitiesAmenityIdRoute,
  AmenitiesManageRoute: AmenitiesManageRoute,
  AmenitiesIndexRoute: AmenitiesIndexRoute,
}

const AmenitiesRouteWithChildren = AmenitiesRoute._addFileChildren(
  AmenitiesRouteChildren,
)

interface GuardRouteChildren {
  GuardIndexRoute: typeof GuardIndexRoute
}

const GuardRouteChildren: GuardRouteChildren = {
  GuardIndexRoute: GuardIndexRoute,
}

const GuardRouteWithChildren = GuardRoute._addFileChildren(GuardRouteChildren)

interface InvitationsRouteChildren {
  InvitationsAccessLogRoute: typeof InvitationsAccessLogRoute
  InvitationsCreateRoute: typeof InvitationsCreateRoute
  InvitationsManageRoute: typeof InvitationsManageRoute
  InvitationsIndexRoute: typeof InvitationsIndexRoute
}

const InvitationsRouteChildren: InvitationsRouteChildren = {
  InvitationsAccessLogRoute: InvitationsAccessLogRoute,
  InvitationsCreateRoute: InvitationsCreateRoute,
  InvitationsManageRoute: InvitationsManageRoute,
  InvitationsIndexRoute: InvitationsIndexRoute,
}

const InvitationsRouteWithChildren = InvitationsRoute._addFileChildren(
  InvitationsRouteChildren,
)

interface TicketsRouteChildren {
  TicketsTicketIdRoute: typeof TicketsTicketIdRoute
  TicketsNewRoute: typeof TicketsNewRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
}

const TicketsRouteChildren: TicketsRouteChildren = {
  TicketsTicketIdRoute: TicketsTicketIdRoute,
  TicketsNewRoute: TicketsNewRoute,
  TicketsIndexRoute: TicketsIndexRoute,
}

const TicketsRouteWithChildren =
  TicketsRoute._addFileChildren(TicketsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AmenitiesRoute: AmenitiesRouteWithChildren,
  DevtoolsRoute: DevtoolsRoute,
  GuardRoute: GuardRouteWithChildren,
  InvitationsRoute: InvitationsRouteWithChildren,
  LoginRoute: LoginRoute,
  MembersRoute: MembersRoute,
  NotificationsRoute: NotificationsRoute,
  PrivacyRoute: PrivacyRoute,
  SettingsRoute: SettingsRoute,
  TermsRoute: TermsRoute,
  TicketsRoute: TicketsRouteWithChildren,
  CommunicationsCreateRoute: CommunicationsCreateRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
